<template>
  <div v-show="show">
    <div class="bg"></div>
    <div :class="['content',(textPlaceholder&&contentPlaceholder)?'height360':(contentPlaceholder?'height300':'height229')]">
      <div class="img"></div>
      <div class="text">
        {{aboveText}}
      </div>
      <div class="text">
        {{belowText}}
      </div>
      <div v-show="contentPlaceholder">
        <input type="text" class="textBorder" v-model="content" placeholder={{contentPlaceholder}}>
      </div>
      <div v-show="textPlaceholder">
        <input type="text" class="textBorder" v-model="text" placeholder={{textPlaceholder}}>
      </div>
      <div class="errorMsg" v-show="contentPlaceholder">{{error}}</div>
      <div class="group">
        <div class="confirm acbtn" @click="confirm">
          确定
        </div>
        <div class="cancel acbtn" @click="cancel">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  ready () {
    window.check = (settings, cb) => {
      this.show = true
      this.aboveText = settings.aboveText ? settings.aboveText : ''
      this.belowText = settings.belowText ? settings.belowText : ''
      this.content = settings.content ? settings.content : ''
      this.contentPlaceholder = settings.contentPlaceholder ? settings.contentPlaceholder : ''
      this.text = settings.text ? settings.text : ''
      this.textPlaceholder = settings.textPlaceholder ? settings.textPlaceholder : ''
      this.cb = cb
    }
  },
  data () {
    return {
      show: false,
      aboveText: '',
      belowText: '',
      content: '',
      error: '',
      text: '',
      textPlaceholder: '',
      contentPlaceholder: '',
      cb: () => {}
    }
  },
  methods: {
    confirm () {
      if (this.content === '' && this.contentPlaceholder) {
        this.error = `${this.contentPlaceholder}不能为空`
      } else if (this.text === '' && this.textPlaceholder) {
        this.error = `${this.textPlaceholder}不能为空`
      } else {
        let obj = {content: this.content, text: this.text}
        this.cb(true, () => {
          this.init()
        }, obj)
      }
    },
    cancel () {
      this.error = ''
      this.cb(false, () => {
        this.init()
      })
    },
    init () {
      this.show = false
      this.aboveText = ''
      this.belowText = ''
      this.cb = null
    }
  }
}
</script>

<style scoped>
.bg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.7);
}

.content {
  position: fixed;
  width: 374px;
  background-color: white;
  padding: 26px 66px;
  box-sizing: border-box;
  left: calc(50% - 187px);
  top: calc(50% - 150px);
  z-index: 1000;
}
.height229{
  height: 229px;
}
.height300{
  height: 300px;
}
.height360{
  height: 360px;
}
.img {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(../images/alert.png);
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
}

.text {
  width: 100%;
  font-size: 15px;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
  color: #707070;
}

.group {
  margin-top: 20px;
}
.confirm, .cancel {
  width: 104px;
  height: 40px;
  color: white;
  text-align: center;
  font-size: 15px;
  border-radius: 5px;
  line-height: 2.7;
  display: inline-block;
  box-sizing: border-box;
  overflow: hidden;
}

.confirm {
  background-color: black;
  float: left;
}

.cancel {
  background-color: #9B9B9B;
  float: right;
}
  .textBorder{
    height: 40px;
    width: 240px;
    box-sizing: border-box;
    padding: 0 10px;
    outline: none;
    border-radius: 5px;
    border: 1px solid #E9E9E9;
    margin-top: 10px;
  }
  .errorMsg{
    padding-top: 10px;
    color: red;
    font-size: 10px;
    text-align: right;
    height: 15px;
    padding-right: 20px;
    box-sizing: border-box;
  }
</style>



/** WEBPACK FOOTER **
 ** Check.vue?56adc9d6
 **/